/* src/components/pages/Djenr.jsx - MOdificado el 05-02-2026 */
/* ------------ declaraciones juradas enrolado ------------- */

import React, { useState, useEffect } from 'react';
import { TextField, Box, Button, Stack, Dialog, DialogTitle, Card, DialogActions,
          DialogContent, FormControlLabel, Divider, Checkbox, CircularProgress,
          Typography, CardContent, CardHeader, MenuItem } from '@mui/material';
import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { exportPdfAsync, downloadBlob } from "../utils/exportUtils";
import { normalizeRut } from "../utils/rutUtils";
import { validarRut } from "../utils/rutValidator";

import { RiFolderDownloadLine, RiShareBoxFill, RiFileSearchLine,
  RiFilePdf2Fill, RiFileList2Fill, RiSlackFill } from "react-icons/ri";

import { useAuth } from "../../context/AuthContext"; // token

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

/* Campos para exportar a Csv */
const CSV_FIELDS = [
  { key: 'id', label: 'Id'},
  { key: 'ano', label: 'Año Tributario'},
  { key: 'foliodj', label: 'Folio Declaración'},
  { key: 'rut', label: 'RUT',},
  { key: 'nombre', label: 'Nombre',},
  { key: 'regimen', label: 'Regimen'},
  { key: 'segmento', label: 'Segmento'},
  { key: 'actividad', label: 'Actividad'},
  { key: 'formulario', label: 'Formulario'},
  { key: 'nomform', label: 'Descripción'},
  { key: 'estado', label: 'Estado'},
  { key: 'presentacion', label: 'Presentacion'},
  { key: 'casos', label: 'Casos' },
  { key: 'tipo', label: 'Tipo' },
  { key: 'medio', label: 'Medio' },
];

const Djenr = ({ modo }) => {
  const { user } = useAuth();

  const [datadjs, setDjs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [enrolados, setEnrolados] = useState([]);
  const [rutSeleccionado, setRutSeleccionado] = useState('');

  const [generandoPdf, setGenerandoPdf] = useState(false);

  const [openCsvDialog, setOpenCsvDialog] = useState(false);

  /* Selecciona todos los campos para Csv */
  const [selectedCsvFields, setSelectedCsvFields] = useState(
    CSV_FIELDS.map(f => f.key)
  );

  /* Estados para paginación desde el servidor */
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [rowCount, setRowCount] = useState(0);
  
  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes

  const [openDialog, setOpenDialog] = useState(false);
  const [rowDetails, setRowDetails] = useState(null);

  /* cargar enrolados asociados al cliente */
  useEffect(() => {
    (async () => {
      try {
        const RutCli = normalizeRut(user.usuario)

        const response = await api.post('/enrolados/enroladosasociados', {
          RutCli,
          RutEnr: '',
          Tipousr: 1, /* Cliente */
        });

        if (response.data.success && response.data.rows) {
          setEnrolados(response.data.rows);
        } else {
          setEnrolados([]);

          showFeedback({
            message: 'No se encontraron registros para los parámetros ingresados',
            severity: 'warning',
          });
        }
      } catch (error) {
        showFeedback({
          message: 'No fue posible obtener su solicitud, por favor intente más tarde',
          severity: 'error',
        });
      }
    })();
  }, [showFeedback, user.usuario]);

  /* Validar rut del enroaldo */
  const rutEnrValido = React.useMemo(() => {
    if (!rutSeleccionado) return false;
    return validarRut(rutSeleccionado);
  }, [rutSeleccionado]);

  /* Función para obtener los datos. recibe la página solicitada */
  const fetchDjs = async ({ page = 0, pageSize = 20 } = {}) => {
    if (!rutSeleccionado) {
      showFeedback({
        message: "Debe seleccionar un enrolado",
        severity: "warning",
      });
      return;
    }
    if (!rutEnrValido) {
      setDjs([]);
      setRowCount(0);
      showFeedback({
        message: "El Rut del enrolado no es válido",
        severity: "error",
      });
      return;
    }

    setLoading(true);

    try {
      const RutCli = normalizeRut(rutSeleccionado);

      const response = await api.post('/dj/getdjs', {
        RutCli,
        page,
        pageSize,
      });

      if (response.data.success && response.data.rows) {
        setDjs(response.data.rows);       // Carga los datos al estado //
        setRowCount(response.data.total); // Total registros //

      } else {
        setDjs([]);
        setRowCount(0);

        showFeedback({
          message: 'No se encontraron registros para los parámetros ingresados',
          severity: 'warning',
        });
      }

    } catch (err) {
      setDjs([]);
      setRowCount(0);

      showFeedback({
        message: 'No fue posible obtener su solicitud, por favor intente más tarde',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  /* Mostrar los detalles de la fila seleccionada */
  const handleRowClick = (row) => {
    setRowDetails(row);
    setOpenDialog(true);  // Abrir el diálogo con los detalles //
  };

  /* exportar a pdf todos los datos de la tabla */
  const exportToPDF = async () => {
    if (!rutSeleccionado || !rutEnrValido) {
      showFeedback({
        message: "Debe seleccionar un enrolado",
        severity: "warning",
      });
      return;
    }

    exportPdfAsync({
      endpointBase: "/dj/pdf",
      payload: {
        RutCli: normalizeRut(rutSeleccionado),
        RutEnr: normalizeRut(rutSeleccionado),
        Tipousr: 2, /* Enrolado */
      },
      onStart: () => setGenerandoPdf(true),
      onFinish: () => setGenerandoPdf(false),
      onError: (msg) => {
        setGenerandoPdf(false);
        showFeedback({
          message: msg,
          severity: "error",
        });
      },
    });
  };

  /* Helpers de Selección de campos para exportar a Csv */
  const toggleCsvField = (fieldKey) => {
    setSelectedCsvFields(prev =>
      prev.includes(fieldKey)
        ? prev.filter(k => k !== fieldKey)
        : [...prev, fieldKey]
    );
  };

  /* Configuración de MUI DataGrid */
  const columns = [
    {
      field: 'pdf',
      headerName: 'PDF',
      width: 50,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,

      renderCell: (params) => {
        const { id } = params.row;

        const handleOpenPDF = async () => {
          if (!id) return;

          try {
            const response = await api.post('/dj/getdjpdf',
              { id },
              { responseType: 'blob' }
            );

            const pdfBlob = new Blob([response.data], {
              type: 'application/pdf',
            });

            const url = window.URL.createObjectURL(pdfBlob);
            window.open(url, '_blank');

            setTimeout(() => {
              window.URL.revokeObjectURL(url);
            }, 1000);

          } catch (error) {
            showFeedback({
              message: 'No fue posible obtener el Pdf',
              severity: 'error',
            });
          }
        };

        return (
          <Button
            variant="contained"
            aria-label="Abrir PDF"
            onClick={handleOpenPDF}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              minWidth: 0,
              padding: 0,
              width: 32,
              height: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.primaryActionHover,
              },
            }}
          >
            <RiFilePdf2Fill size={20} />
          </Button>
        );
      },
    },
    {
      field: 'detalle',
      headerName: "Info",
      width: 70,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => handleRowClick(params.row)}
          sx={{
            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,
            minWidth: 0,
            padding: 0,
            width: 32,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.primaryActionHover,
            },
          }}
        >
          <RiFileList2Fill size={22} />
        </Button>
      ),

    },
    {
      field: "fecha",
      headerName: "Fecha Actualización",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (!params.value) return "—";
        return new Date(params.value).toLocaleString("es-CL");
      },
    },
    {
      field: 'foliodj',
      headerName: "Folio Dj",
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'ano',
      headerName: "Año Dj",
      width: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'rut',
      headerName: "Rut Contribuyente",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nombre',
      headerName: "Razón Social",
      width: 280,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'formulario',
      headerName: "Formulario",
      width: 100,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'estado',
      headerName: "Estado",
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'presentacion',
      headerName: "Presentación",
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },
    // {
    //   field: 'spacer',
    //   headerName: '',
    //   width: 160,
    //   sortable: false,
    //   filterable: false,
    //   disableColumnMenu: true,   // ❗ elimina los 3 puntos
    //   disableReorder: true,      // evita que se arrastre
    //   disableExport: true,
    //   align: 'center',
    //   headerAlign: 'center',
    //   renderCell: () => null,    // ❗ evita que se vea algo raro
    // }
  ];

  /* Llama a crear Csv */
  const handleExportCsv = async () => {
    try {
      if (!rutSeleccionado || !rutEnrValido) {
        showFeedback({
          message: "Debe seleccionar un enrolado",
          severity: "warning",
        });
        return;
      }

      const RutCli = normalizeRut(rutSeleccionado);

      const response = await api.post('/dj/csv',
        {
          RutCli,
          fields: selectedCsvFields,
        },
        {
          responseType: 'blob',
        }
      );

      downloadBlob(response.data, "dj_enrolado.csv");
      setOpenCsvDialog(false);

    } catch (error) {
      showFeedback({
        message: 'No fue posible exportar el CSV',
        severity: 'error',
      });
    }
  };

  /* Render */
  return (
    <Box sx={{ width: '100%', pt: 0, overflow: 'visible' }}>
      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
              textAlign: 'center',
              letterSpacing: '0.03em',
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Selector de enrolados */}
        <TextField
          select
          id="enrolado-selector"
          label="Enrolado"
          value={rutSeleccionado}
          size="small"
          onChange={(e) => {
            const rut = e.target.value;
            setRutSeleccionado(rut);
            setDjs([]);
            setRowCount(0);
            setPage(0);
          }}
          variant="outlined"
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        >
          {enrolados.length > 0 ? (
            enrolados.map((item) => (
              <MenuItem key={item.rut_enr} value={item.rut_enr}>
                {item.nombre_enr || item.rut_enr}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No hay registros</MenuItem>
          )}
        </TextField>


        {/* Botón Buscar */}
        <Button
          variant="contained"
          startIcon={<RiFileSearchLine size={18} />}
          onClick={() => {
            setPage(0);
            fetchDjs({ page: 0, pageSize });
          }}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,

            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,

            '&:hover': {
              backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
            },
          }}
        >
          Buscar
        </Button>


        {/* Botón Exportar a Pdf */}
        <Button
          variant="contained"
          startIcon={<RiFolderDownloadLine size={18} />}
          disabled={datadjs.length === 0}
          onClick={exportToPDF}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          PDF
        </Button>

        {/* Botón Exportar a Csv */}
        <Button
          variant="contained"
          startIcon={<RiShareBoxFill size={18} />}
          disabled={datadjs.length === 0}
          onClick={() => setOpenCsvDialog(true)}
          sx={{
            minWidth: 110,
            height: 40,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          CSV
        </Button>
      </Stack>


      {/* Configuración MIU DataGrid */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 210px)', // ajusta según tu layout
          minHeight: 0,
        }}
       >
        <DataGrid
          rows={datadjs}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          paginationMode="server"
          rowCount={rowCount}
          pageSizeOptions={[10, 20, 50, 100]}
          paginationModel={{ page, pageSize }}

          onPaginationModelChange={({ page: newPage, pageSize: newPageSize }) => {
            const isPageSizeChange = newPageSize !== pageSize;

            const finalPage = isPageSizeChange ? 0 : newPage;

            setPage(finalPage);
            setPageSize(newPageSize);

            fetchDjs({
              page: finalPage,
              pageSize: newPageSize,
            });
          }}

          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            flex: 1,
            width: '100%',
            minWidth: 720,      // scroll horizontal cuando corresponde
            border: 'none',
            // accesibilidad / foco
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {rowCount.toLocaleString('es-CL')} registros encontrados
      </Typography>

      {/* Dialogo generando pdf */}
      <Dialog
        open={generandoPdf}
        aria-labelledby="generando-pdf-title"
        aria-describedby="generando-pdf-desc"

        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 3,
              textAlign: 'center',
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
            }),
          },
        }}
      >
        <DialogContent>
          <Stack spacing={2} alignItems="center" py={2}>
            <CircularProgress
              size={42}
              thickness={4}
              sx={{
                color: (theme) => theme.custom.ui.focus,
              }}
            />

            <Typography id="generando-pdf-title" variant="body2">
              Generando reporte
            </Typography>

            <Typography
              id="generando-pdf-desc"
              variant="caption"
              color="text.secondary"
            >
              Estamos trabajando en ello…
            </Typography>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* Dialogo selección de campos para Csv desde el backend */}
      <Dialog
        open={openCsvDialog}
        onClose={() => setOpenCsvDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              mb: 0,
              color: (theme) => theme.custom.ui.brandAccent,
              fontSize: '1.4rem'
            }}>
            Exportar CSV
          </Box>
        </DialogTitle>

        <Divider />

        <DialogContent>
          <Box sx={{ mb: 1, color: 'text.secondary', fontSize: '0.85rem' }}>
            Selecciona los campos que deseas incluir en el archivo.
          </Box>

          <Stack spacing={0.5}>
            {CSV_FIELDS.map(field => (
              <FormControlLabel
                key={field.key}
                control={
                  <Checkbox
                    checked={selectedCsvFields.includes(field.key)}
                    onChange={() => toggleCsvField(field.key)}
                  />
                }
                label={field.label}
              />
            ))}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenCsvDialog(false)}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            disabled={selectedCsvFields.length === 0}
            onClick={handleExportCsv}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
              },
            }}
          >
            Exportar
          </Button>

        </DialogActions>
      </Dialog>

      {/* Dialog para mostrar los detalles de la fila */}
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenDialog(false);
        }}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
        aria-labelledby="dj-detalle-title"
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 8,
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
              border: `1px solid ${theme.custom.ui.borderSubtle}`,
            }),
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          id="dj-detalle-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
          }}
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <RiSlackFill
              size={22}
              color="inherit"
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: '0.04em',
                color: (theme) => theme.custom.ui.brandAccent,
              }}
            >
              Detalles de la Declaración
            </Typography>
          </Stack>

          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: (theme) =>
                theme.custom.ui.secondaryActionBg,
              color: (theme) =>
                theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cerrar
          </Button>
        </DialogTitle>

        <Divider
          sx={{
            borderColor: (theme) => theme.custom.ui.borderSubtle,
            opacity: 0.9,
          }}
        />

        {/* Contenido */}
        <DialogContent
          sx={{
            maxHeight: '75vh',
            overflowY: 'auto',
            px: 3,
            py: 3,
          }}
        >
          {rowDetails && (
            <Stack spacing={3}>
              {/* Datos del Contribuyente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos del Contribuyente"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut', rowDetails.rut],
                    ['Razón Social', rowDetails.nombre],
                    ['Régimen', rowDetails.regimen],
                    ['Segmento', rowDetails.segmento],
                    ['Actividad', rowDetails.actividad],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos del Formulario */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos del Formulario"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Formulario', rowDetails.formulario],
                    ['Nombre', rowDetails.nomform],
                    ['Folio', rowDetails.foliodj],
                    ['Presentación', rowDetails.presentacion],
                    ['Estado', rowDetails.estado],
                    ['Casos', rowDetails.casos],
                    ['Tipo', rowDetails.tipo],
                    ['Medio', rowDetails.medio],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>
            </Stack>
          )}
        </DialogContent>
      </Dialog>

    </Box>
  );
};

export default Djenr;
